import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-read",
  "use": "icon-read-usage",
  "viewBox": "0 0 151 152.3",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 151 152.3\" id=\"icon-read\">\r\n<g>\r\n\t<path class=\"st0\" d=\"M117.3,12.5v11.4h-16.1c-4.3,0-7.8-3.5-7.8-7.8V0h11.4C111.7,0,117.3,5.6,117.3,12.5z\" />\r\n\t<path class=\"st0\" d=\"M117.3,114.1v16.5c0,0.3,0,0.5,0,0.8l-11.7,11.7c-0.3,0-0.5,0-0.8,0H89.5l0.3-1.6L117.3,114.1z\" />\r\n\t<path class=\"st0\" d=\"M101.2,33.3c-9.5,0-17.2-7.7-17.2-17.2V0H12.5C5.6,0,0,5.6,0,12.5v118c0,6.9,5.6,12.5,12.5,12.5h67.4l0.9-4.6\r\n\t\tc0.2-1,0.7-2,1.5-2.8l34.9-34.9V33.3H101.2z M85.9,119.7H31.4c-2.6,0-4.7-2.1-4.7-4.7s2.1-4.7,4.7-4.7h54.5c2.6,0,4.7,2.1,4.7,4.7\r\n\t\tS88.5,119.7,85.9,119.7z M85.9,88.4H31.4c-2.6,0-4.7-2.1-4.7-4.7s2.1-4.7,4.7-4.7h54.5c2.6,0,4.7,2.1,4.7,4.7S88.5,88.4,85.9,88.4z\r\n\t\t\" />\r\n\t<path class=\"st0\" d=\"M149.2,99.3l-50.8,50.8l-10.8,2.2l1.9-9.2l0.3-1.6l50.8-50.8c2.3-2.3,6.3-2.3,8.6,0\r\n\t\tC151.6,93.1,151.6,96.9,149.2,99.3L149.2,99.3z\" />\r\n</g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/read.svg
// module id = 7/AS
// module chunks = 19